//------- import Libraries
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";

import {
  DollarIcon,
  PercentageIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
} from "../../../../constants";
import {
  inventoryActions,
  shopifyActions,
  systemActions,
} from "../../../../redux/actions";
import {
  Barcode,
  Button,
  CategoriesDropdown,
  CheckboxField,
  Description,
  InputNumberField,
  InputTextField,
  Rarity,
  SelectCardRarity,
  SelectGrade,
  SelectLanguage,
  Set,
  ToggleButtonWithText,
} from "../../../../shared/components";
import {
  getProductSubCategory,
  handleBeautifyMarketPrice,
  handleConditionChange,
  handleIsLinkToShopify,
  handleShowNintendoCondition,
  isMarketPriceHigh,
  isSystemProduct,
  isTcgPlayerApi,
} from "../../../../shared/utility";
import {
  CustomItemCategorySelectField,
  CustomItemConditionSelectField,
  CustomItemProductTypeSelectField,
  CustomItemSubcategorySelectField,
} from "../../Shared";

const EditInventoryRightColumn = (props) => {
  const {
    // Parent component states
    state,
    values,
    isCustomItem,
    selectedTags,
    setFieldValue,
    conditionList,
    setSelectedTags,
    setConditionList,
    productCondition,
    handlePriceChange,
    productDataObject,
    setProductTagsList,
    handleCancelButton,
    setProductDataObject,
    setProductCondition,
    isShopifyStoreConnected,
    handleIsLinkToShopifyCheck,
    handleSeparateOnlineQuantityChange,
    // Redux states
    productTags,
    customTypes,
    currentStore,
    customCategories,
    customSubCategories,
    priceChartingProductInfo,
    setPriceChartingProductInfo,
  } = props;
  const handleTrackQuantityChange = (name, value, setFieldValue) => {
    setFieldValue("unitsOnHand", value ? state?.data?.price?.quantity : "");
  };

  return (
    <Col className="" md={7} sm={12}>
      <div className="edit-invetory-left ">
        <Row className="p-0 m-0 left-container p-0">
          <Row className=" m-0 p-0">
            {/* Item details */}
            <Row className="m-0 py-3 edit-items-detail-wrapper px-1">
              <Col md={6} className="pricing-Text d-flex align-items-center">
                Item Details
              </Col>
              {isShopifyStoreConnected && (
                <Col
                  md={6}
                  className="d-flex justify-content-end align-items-center"
                >
                  <CheckboxField
                    key={`${values?.onlineQuantity}-${values?.unitsOnHand}`}
                    name="isLinkToShopify"
                    label="Link to Shopify"
                    isLabelLeft={true}
                    handleChange={(name, value) => {
                      handleIsLinkToShopifyCheck(
                        name,
                        value,
                        values,
                        setFieldValue
                      );
                    }}
                  />
                </Col>
              )}
              <Row className="mx-auto px-0">
                <Col className="mt-3">
                  <InputTextField
                    label="Title"
                    maxLength={100}
                    className="border"
                    name="productName"
                    placeHolder="Enter Title"
                    disabled={!isCustomItem}
                  />
                </Col>
                {isTcgPlayerApi(state?.data) && (
                  <Col md={4} className="mt-3">
                    <SelectGrade
                      label="Grading"
                      value={values.grade}
                      setFieldValue={setFieldValue}
                      conditionComponent={{
                        setConditionList: setConditionList,
                        setProductCondition: setProductCondition,
                      }}
                      priceChartingProductInfo={priceChartingProductInfo}
                      setPriceChartingProductInfo={setPriceChartingProductInfo}
                    />
                  </Col>
                )}
                <Col md={4} className=" mt-3">
                  {isCustomItem ? (
                    <CustomItemConditionSelectField
                      customTypes={customTypes}
                      values={values}
                    />
                  ) : (
                    <CategoriesDropdown
                      options={conditionList}
                      disabled={false}
                      handleChange={(selectedOption) => {
                        state.data.tags = [];
                        return handleConditionChange(
                          selectedOption,
                          setProductCondition,
                          priceChartingProductInfo,
                          productTags,
                          setProductTagsList,
                          setProductDataObject,
                          productDataObject,
                          setSelectedTags,
                          setPriceChartingProductInfo
                        );
                      }}
                      noOptionsMessage="Empty Box"
                      label={"Condition"}
                      placeholder={handleShowNintendoCondition(
                        state?.data?.category_name,
                        state?.data?.price?.type
                      )}
                      SelectIconImage={categoryDropdownConstants.BOX_ICON}
                      isClearable={false}
                      value={productCondition}
                    />
                  )}
                </Col>
              </Row>
              <Col md={4} className="mt-3">
                <CustomItemProductTypeSelectField
                  setFieldValue={setFieldValue}
                  customTypes={customTypes}
                  isDisabled={!isCustomItem}
                />
              </Col>
              <Col md={4} className="mt-3">
                <CustomItemCategorySelectField
                  setFieldValue={setFieldValue}
                  customCategories={customCategories}
                  values={values}
                  isDisabled={!isCustomItem}
                />
              </Col>
              <Col md={4} className="mt-3">
                <CustomItemSubcategorySelectField
                  setFieldValue={setFieldValue}
                  values={values}
                  customTypes={customTypes}
                  customCategories={customCategories}
                  customSubCategories={customSubCategories}
                  isDisabled={!isCustomItem}
                />
              </Col>
              {isTcgPlayerApi(state?.data) && (
                <Col md={6} className="mt-3">
                  <SelectLanguage
                    label="Language"
                    value={values.language}
                    setFieldValue={setFieldValue}
                    priceChartingProductInfo={priceChartingProductInfo}
                    setPriceChartingProductInfo={setPriceChartingProductInfo}
                    setPriceChartingProductInfoComponent={setProductDataObject}
                  />
                </Col>
              )}
              {isTcgPlayerApi(state?.data) && state?.data?.cardRarity && (
                <Col md={6} className="mt-3">
                  <SelectCardRarity
                    label="Printing"
                    value={values.cardRarity}
                    setFieldValue={setFieldValue}
                    priceChartingProductInfo={priceChartingProductInfo}
                    setPriceChartingProductInfo={setPriceChartingProductInfo}
                    setPriceChartingProductInfoComponent={setProductDataObject}
                  />
                </Col>
              )}
              {isTcgPlayerApi(state?.data) && (
                <Col md={6} className="mt-3">
                  <Set
                    label="Set"
                    value={values.set}
                    setFieldValue={setFieldValue}
                    priceChartingProductInfo={priceChartingProductInfo}
                  />
                </Col>
              )}
              {isTcgPlayerApi(state?.data) && (
                <Col md={6} className="mt-3">
                  <Rarity
                    label="Rarity"
                    value={values.rarity}
                    setFieldValue={setFieldValue}
                    priceChartingProductInfo={priceChartingProductInfo}
                  />
                </Col>
              )}
              {isTcgPlayerApi(state?.data) && (
                <>
                  <Col md={6} className="mt-3">
                    <Barcode
                      label="Barcode"
                      value={values.barcode}
                      setFieldValue={setFieldValue}
                      priceChartingProductInfo={priceChartingProductInfo}
                    />
                  </Col>
                </>
              )}
              {isSystemProduct(
                getProductSubCategory(productDataObject?.genre)
              ) && (
                <Col md={6} className="mt-3">
                  <InputTextField
                    label="Serial Number"
                    name="serialNumber"
                    maxLength={100}
                    placeHolder="Enter Serial Number"
                    className="border add-inventory-serial-number-field"
                    handleChange={() => {
                      if (
                        values?.serialNumber &&
                        (values.unitsOnHand > 1 || values.onlineQuantity > 1)
                      ) {
                        setFieldValue("onlineQuantity", 1);
                        setFieldValue("unitsOnHand", 1);
                      }
                    }}
                  />
                </Col>
              )}
              {isCustomItem && (
                <>
                  <Col md={6} className="mt-3">
                    <InputTextField
                      name="upc"
                      placeHolder=""
                      className="border"
                      label="UPC (Optional)"
                    />
                  </Col>
                  <Col md={6} className="mt-3">
                    <Description />
                  </Col>
                </>
              )}
            </Row>
            {/* Quantity section */}
            <Row className="mt-4 pricing-Div m-0 pb-3 px-1">
              <Col md={6} className="pricing-Text d-flex align-items-center">
                Quantity
              </Col>
              <Col
                md={6}
                className="d-flex flex-column justify-content-end align-items-end"
              >
                {isCustomItem && (
                  <CheckboxField
                    name="trackQuantity"
                    label="Track Quantity"
                    isLabelLeft={true}
                    handleChange={(name, value) => {
                      handleTrackQuantityChange(name, value, setFieldValue);
                    }}
                  />
                )}
                {handleIsLinkToShopify(currentStore, values) && (
                  <CheckboxField
                    key={`${values?.onlineQuantity}-${values?.unitsOnHand}`}
                    name="isOnlineQuantity"
                    label="Separate In-Store & Online Quantities"
                    isLabelLeft={true}
                    handleChange={(name, value) => {
                      handleSeparateOnlineQuantityChange(
                        name,
                        value,
                        values,
                        setFieldValue
                      );
                    }}
                  />
                )}
              </Col>
              <Col md={6} className="mt-2">
                <InputNumberField
                  name="unitsOnHand"
                  placeHolder={`Quantity (${
                    values.isOnlineQuantity ? "In-Store" : "All Available"
                  }):`}
                  type="number"
                  isConvertToDecimal={false}
                  isHandleKeyDown={true}
                  min={-9999}
                  step={"1"}
                  pattern="-?[0-9]+"
                  label={`Quantity (${
                    values.isOnlineQuantity ? "In-Store" : "All Available"
                  }):`}
                  disabled={!values?.trackQuantity || values?.serialNumber}
                />
              </Col>
              <Col md={6} className="mt-2">
                {values.isOnlineQuantity &&
                  handleIsLinkToShopify(currentStore, values) && (
                    <InputNumberField
                      name="onlineQuantity"
                      placeHolder={"Quantity (Online):"}
                      type="number"
                      isConvertToDecimal={false}
                      isHandleKeyDown={true}
                      min={-9999}
                      step={"1"}
                      pattern="-?[0-9]+"
                      label="Quantity (Online):"
                      disabled={!values?.trackQuantity || values?.serialNumber}
                    />
                  )}
              </Col>
            </Row>
            {/* Pricing section */}
            <Row className="mt-4 pricing-Div pb-3 m-0 px-0 ">
              <Col
                md={12}
                className="d-flex justify-content-between align-items-center"
              >
                <div className="d-flex align-items-center gap-2 ">
                  <span className="pricing-Text">Pricing</span>
                  {handleIsLinkToShopify(currentStore, values) && (
                    <ToggleButtonWithText
                      isToggle={values.isInstoreStockPrice}
                      handleLeftButtonClick={() => {
                        handlePriceChange(
                          values,
                          undefined,
                          undefined,
                          setFieldValue,
                          false
                        );
                      }}
                      handleRightButtonClick={() => {
                        handlePriceChange(
                          values,
                          undefined,
                          undefined,
                          setFieldValue,
                          true
                        );
                      }}
                      leftButtonLabel="In-Store"
                      rightButtonLabel="Online"
                      className="discount-toggle-button add-inventory-quantity-toggle-switch"
                    />
                  )}
                </div>
                {/* {values.isLinkToShopify && (
                                    <CheckboxField
                                      name="isOnlineUnitSellPrice"
                                      label="Different Online Price"
                                      isLabelLeft={true}
                                      handleChange={(name, value) => {
                                        handlePriceChange(
                                            values,
                                            undefined,
                                            undefined,
                                            setFieldValue,
                                            value
                                          );
                                      }}
                                    />
                                  )} */}
              </Col>

              <Col md={4} className="mt-3 ">
                <InputNumberField
                  name={
                    values.isInstoreStockPrice
                      ? "onlineUnitSellPrice"
                      : "unitsellprice"
                  }
                  handleChange={(value) =>
                    handlePriceChange(values, undefined, value, setFieldValue)
                  }
                  placeHolder="$74.99"
                  type="number"
                  label={
                    values.isInstoreStockPrice ? "Online Price" : "Stock Price"
                  }
                  disabled={false}
                  IconImage={DollarIcon}
                  className={`${
                    isMarketPriceHigh(
                      handleBeautifyMarketPrice(productDataObject),
                      values.unitsellprice,
                      productTags,
                      selectedTags
                    ) && values.unitsellprice
                      ? "border-danger"
                      : ""
                  }`}
                />
              </Col>
              <Row className="mt-3 p-0 m-0">
                <Col md={4} className="">
                  <InputNumberField
                    name={
                      values.isInstoreStockPrice && values?.isOnlineQuantity
                        ? "onlineCostPerItem"
                        : "costPerItem"
                    }
                    label="Cost per Item: "
                    placeHolder="$74.99"
                    type="number"
                    IconImage={DollarIcon}
                    handleChange={(value) =>
                      handlePriceChange(values, value, undefined, setFieldValue)
                    }
                  />
                </Col>
                <Col md={4} className="">
                  <InputTextField
                    name={
                      values.isInstoreStockPrice ? "onlineProfit" : "profit"
                    }
                    placeHolder="0.00"
                    label={"Profit:"}
                    IconImage={DollarIcon}
                    disabled={true}
                  />
                </Col>
                <Col md={4} className="">
                  <InputTextField
                    name={
                      values.isInstoreStockPrice ? "onlineMargin" : "margin"
                    }
                    placeHolder="0.00"
                    label={"Profit Margin"}
                    LeftIconImage={PercentageIcon}
                    disabled={true}
                  />
                </Col>
              </Row>
            </Row>
          </Row>
        </Row>
      </div>
      <Row className="w-100 m-0">
        <Col md={8} className="mt-3 pb-4 pe-0 d-flex gap-2 ms-auto">
          <Button
            type="button"
            label={buttonNameConstants.CANCEL}
            buttonType={buttonTypeConstants.GHOST_BUTTON}
            className="w-100"
            handleClick={() => {
              handleCancelButton();
            }}
          ></Button>
          <Button
            type="submit"
            className="w-100"
            label={buttonNameConstants.SAVE}
          ></Button>
        </Col>
      </Row>
    </Col>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  productTags: state.inventory.productTags,
  customTypes: state.itemOrganization.customTypes,
  currentStore: state.store.currentStore,
  customCategories: state.itemOrganization.customCategories,
  customSubCategories: state.itemOrganization.customSubCategories,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
});

//-------Export EditInventory Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInventoryRightColumn);
